import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormik } from 'formik';
import { useCallback } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { validationSchema } from './constant';

export interface RegisterCertificationForm {
  initials: string;
  type: string;
  description: string;
}

interface FormProps {
  onOk: (form?: RegisterCertificationForm) => void;
  onCancel: () => void;
  title: string;
  disabled?: boolean;
  mode?: 'NEW' | 'EDIT' | 'DETAIL';
  initialValues?: RegisterCertificationForm;
}

const Form = ({
  onOk,
  onCancel,
  title,
  disabled = false,
  initialValues,
  mode,
}: FormProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const formRegisterCertificationValue = useFormik({
    initialValues: initialValues || {
      initials: '',
      type: '',
      description: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={formRegisterCertificationValue.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Tipo registro"
                  label="Tipo registro *"
                  id="type"
                  name="type"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={formRegisterCertificationValue.values.type}
                  onChange={formRegisterCertificationValue.handleChange}
                  error={
                    formRegisterCertificationValue.touched.type &&
                    Boolean(formRegisterCertificationValue.errors.type)
                  }
                  helperText={formRegisterCertificationValue.errors.type}
                  inputProps={{
                    maxLength: '8',
                  }}
                  disabled={disabled || mode === 'EDIT'}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <PmiTextField
                  aria-label="Sigla registro"
                  label="Sigla registro *"
                  id="initials"
                  name="initials"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={formRegisterCertificationValue.values.initials}
                  onChange={formRegisterCertificationValue.handleChange}
                  error={
                    formRegisterCertificationValue.touched.initials &&
                    Boolean(formRegisterCertificationValue.errors.initials)
                  }
                  helperText={formRegisterCertificationValue.errors.initials}
                  inputProps={{
                    maxLength: '1',
                  }}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <PmiTextField
                  aria-label="Descrizione registro"
                  label="Descrizione registro *"
                  id="description"
                  name="description"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={formRegisterCertificationValue.values.description}
                  onChange={formRegisterCertificationValue.handleChange}
                  error={
                    formRegisterCertificationValue.touched.description &&
                    Boolean(formRegisterCertificationValue.errors.description)
                  }
                  helperText={formRegisterCertificationValue.errors.description}
                  inputProps={{
                    maxLength: '50',
                  }}
                  disabled={disabled}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

Form.displayName = 'Form Feature valore component';

export default Form;
